/* eslint-disable */
import Vue from 'vue'
import "@weihai/lc-component/lib/lc.css";
import lcComponent from "@weihai/lc-component";

Vue.use(lcComponent, {
  env: process.env.NODE_ENV,
  appEnv: process.env.VUE_APP_ENV,
});
